/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase2_Fix_Public_Tool_Bad_InputInputs */

const en_phase2_fix_public_tool_bad_input = /** @type {(inputs: Phase2_Fix_Public_Tool_Bad_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the input and try again.`)
};

const zh_hans1_phase2_fix_public_tool_bad_input = /** @type {(inputs: Phase2_Fix_Public_Tool_Bad_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请检查输入后重试。`)
};

const pt_br2_phase2_fix_public_tool_bad_input = /** @type {(inputs: Phase2_Fix_Public_Tool_Bad_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confira os dados informados e tente de novo.`)
};

const es_phase2_fix_public_tool_bad_input = /** @type {(inputs: Phase2_Fix_Public_Tool_Bad_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa la entrada e inténtalo de nuevo.`)
};

const fr_phase2_fix_public_tool_bad_input = /** @type {(inputs: Phase2_Fix_Public_Tool_Bad_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez la saisie et réessayez.`)
};

const de_phase2_fix_public_tool_bad_input = /** @type {(inputs: Phase2_Fix_Public_Tool_Bad_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfe die Eingabe und versuch es erneut.`)
};

const ru_phase2_fix_public_tool_bad_input = /** @type {(inputs: Phase2_Fix_Public_Tool_Bad_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте ввод и повторите попытку.`)
};

const it_phase2_fix_public_tool_bad_input = /** @type {(inputs: Phase2_Fix_Public_Tool_Bad_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla l'input e riprova.`)
};

/**
* | output |
* | --- |
* | "Check the input and try again." |
*
* @param {Phase2_Fix_Public_Tool_Bad_InputInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const phase2_fix_public_tool_bad_input = /** @type {((inputs?: Phase2_Fix_Public_Tool_Bad_InputInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase2_Fix_Public_Tool_Bad_InputInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_phase2_fix_public_tool_bad_input(inputs)
	if (locale === "pt-BR") return pt_br2_phase2_fix_public_tool_bad_input(inputs)
	if (locale === "es") return es_phase2_fix_public_tool_bad_input(inputs)
	if (locale === "fr") return fr_phase2_fix_public_tool_bad_input(inputs)
	if (locale === "de") return de_phase2_fix_public_tool_bad_input(inputs)
	if (locale === "ru") return ru_phase2_fix_public_tool_bad_input(inputs)
	if (locale === "it") return it_phase2_fix_public_tool_bad_input(inputs)
	return en_phase2_fix_public_tool_bad_input(inputs)
});